import React, { Component } from 'react';
import Loader from '../components/loader';
import Modal from '../components/modal';
import Button from '../components/button/button';
import FormSelectField from '../components/form/select-field';
import { Desktop, Mobile } from '../app-responsive';
import { getProductNameText, getDecryptedText, getEventRouteAndUserHashDetails, getCidnValue } from '../app-actions';
import { PRODUCT_SELECTION_HEADING, COMPANY_NAME_PREFIX, ERROR_CONTENT_404, SECURE_AUTH_PARTNER_BY_PASS } from '../app-constants';
import ViewHeader from '../components/view-header';
import AppWrapper from '../app-wrapper';
import { customStylesDesktop, customStylesMobile } from '../components/business-case-delete-modal/modal-styles-config';
import './authorable-content.css';

class AuthorableContentView extends Component {
  state = {
    cidnKey: '',
  };
  componentDidMount() {
    const eventRouteDetails = getEventRouteAndUserHashDetails();
    if (eventRouteDetails.isEventRouteAndUserHashPresent
        || eventRouteDetails.isHostedRoutePresent
        || eventRouteDetails.isBusinessPopMailRoutePresent
        || eventRouteDetails.isAdaptiveMobilityExternalPresent) {
      const { getAEMContentForPurlApps } = this.props.actions;
      getAEMContentForPurlApps();
    } else if (eventRouteDetails.isPartnerView) {
      const hostname = window.location.hostname;
      if (this.props.secureAuthAuthenticated === false && window.location.search.length > 2 && SECURE_AUTH_PARTNER_BY_PASS === false) {
        const { getSecureAuthToken } = this.props.actions;
        getSecureAuthToken();
      } else if (SECURE_AUTH_PARTNER_BY_PASS) {
        const { getSecureAuthToken } = this.props.actions;
        getSecureAuthToken();
      } else {
        const { getAEMContentForPurlApps } = this.props.actions;
        getAEMContentForPurlApps();
      }
    } else {
      const { getAEMContent } = this.props.actions;
      getAEMContent();
    }
  }

  componentDidUpdate(prevProps) {
    const eventRouteDetails = getEventRouteAndUserHashDetails();
    if (prevProps.secureAuthAuthenticated !== this.props.secureAuthAuthenticated && eventRouteDetails.isPartnerView) {
      const { getAEMContentForPurlApps } = this.props.actions;
      getAEMContentForPurlApps();
    }
  }

  onProductSelection = (product) => {
    const { loadSelectedProduct } = this.props.actions;
    loadSelectedProduct({ productType: product });
  };

  onUCidnSelectionChange = (event) => {
    const { getProductSelectionForUCidnSelection } = this.props.actions;
    window.tcom.researchInsights.appConfig.currentAccount = event.target.value;
    getProductSelectionForUCidnSelection(event.target.value);
  };

  adjustUcidnModalHeight = () => {
    const modalElement = document.getElementsByClassName('ucidn-account-modal-body')[0];
    if (modalElement) {
      const { uCidnSelectionList } = this.props;
      const newModalHeight = uCidnSelectionList.length * 70;
      modalElement.style.height = `${newModalHeight <= 600 ? newModalHeight + 200 : 600}px`;
    }
  }

  render() {
    const {
      contentLoading,
      showProductSelection,
      productSelectionList,
      uCidnSelectionList,
      showUCidnList,
      showAccountProductChange,
      accountKey,
      productError,
    } = this.props;
    const desktopModalStyles = { content: { ...customStylesDesktop.content, width: '40%' } };

    if (window === window.parent) {
      console.log('main app window');
      if (showProductSelection === false && showUCidnList === false && productError === false) {
        return contentLoading ? <Loader position="authorable" /> : this.props.children;
      } else if (productError) {
        const errorContent = {
          heading: ERROR_CONTENT_404.heading,
          description: ERROR_CONTENT_404.description,
        };
        return (
          <AppWrapper>
            <div className="container root-container container-fluid ri-product-error">
              <ViewHeader content={errorContent} productError />
            </div>
          </AppWrapper>
        );
      }
    } else {
      console.log('iframe renewal authorable');
      return '';
    }


    const productListContent = productSelectionList.map(product => (
      <div className="row product-selection-row text-center" key={product}>
        <div className="col-12">
          <Button
            className="button do-business"
            buttonText={getProductNameText(product)}
            onClick={() => this.onProductSelection(product)}
          />
        </div>
      </div>
    ));

    const cidnListOptions = uCidnSelectionList.map((cidnItem) => {
      const cidnValue = getDecryptedText(cidnItem.encryptedCidn);
      return {
        key: cidnItem.encryptedCidn,
        value: `${COMPANY_NAME_PREFIX} ${cidnItem.accountName} (${cidnValue})`,
      };
    });

    const modalContentUCidn = customStyles => (
      <Modal
        isOpen={showProductSelection || showUCidnList}
        style={customStyles}
        className="ucidn-account-modal-body"
      >
        <h2 className="text-center">Please select an Account from the list</h2>
        <div className="ucidn-account-modal">
          <FormSelectField
            id="cidn-account-selection-list"
            label=""
            disabled={false}
            onBlur={this.onUCidnSelectionChange}
            placeholder="Please Select"
            value={getCidnValue(this.state.cidnKey, uCidnSelectionList, false)}
            options={cidnListOptions}
            sendKeyValueOnChange
            showScrollBar
            parentCompFunction={this.adjustUcidnModalHeight}
            searchCapable
          />
        </div>
        {showProductSelection && (
          <React.Fragment>
            <h2 className="text-center">{PRODUCT_SELECTION_HEADING}</h2>
            {productListContent}
          </React.Fragment>
        )}
      </Modal>
    );

    const modalContentAccountChange = customStyles => (
      <Modal
        isOpen={showAccountProductChange}
        style={customStyles}
      >
        <h2 className="text-center">{getDecryptedText(accountKey)}</h2>
        <h2 className="text-center">{PRODUCT_SELECTION_HEADING}</h2>
        {productListContent}
      </Modal>
    );

    const modalContent = customStyles => (
      <Modal
        isOpen={showProductSelection}
        style={customStyles}
      >
        <h2 className="text-center">{PRODUCT_SELECTION_HEADING}</h2>
        {productListContent}
      </Modal>
    );
    return (
      <React.Fragment>
        {showAccountProductChange === false && (
          <React.Fragment>
            <Mobile>
              {showUCidnList && (
                modalContentUCidn(customStylesMobile)
              )}
              {!showUCidnList && (
                modalContent(customStylesMobile)
              )}
            </Mobile>
            <Desktop>
              {showUCidnList && (
                modalContentUCidn(desktopModalStyles)
              )}
              {!showUCidnList && (
                modalContent(desktopModalStyles)
              )}
            </Desktop>
          </React.Fragment>
        )}
        {showAccountProductChange && (
          <React.Fragment>
            <Mobile>
              {modalContentAccountChange(customStylesMobile)}
            </Mobile>
            <Desktop>
              {modalContentAccountChange(desktopModalStyles)}
            </Desktop>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default AuthorableContentView;
